import { Box, Button, Typography } from '@mui/material';
import { ErrorOutline as ErrorIcon, InboxOutlined as EmptyIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { colors } from '@src/styles';
import { fadeInUpSX } from '@src/styles/animations';

type StateMessageProps = {
  variant: 'empty' | 'error';
  title: string;
  description?: string;
  onRetry?: () => void;
};

export const StateMessage = ({ variant, title, description, onRetry }: StateMessageProps) => {
  const isError = variant === 'error';
  const accent = isError ? colors.primary.warning : colors.runs.textSecondary;
  const Icon = isError ? ErrorIcon : EmptyIcon;

  return (
    <Box
      sx={{
        ...fadeInUpSX(),
        flex: 1,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        pt: 10,
        px: 3,
        textAlign: 'center',
      }}
    >
      <Icon sx={{ fontSize: 40, color: accent, opacity: isError ? 1 : 0.5 }} />
      <Typography sx={{ fontFamily: 'archivo', fontWeight: 600, fontSize: 16, color: colors.primary.white }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ fontSize: 13, color: colors.runs.textSecondary, maxWidth: 420 }}>{description}</Typography>
      )}
      {onRetry && (
        <Button
          onClick={onRetry}
          startIcon={<RefreshIcon />}
          variant="outlined"
          sx={{
            mt: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            color: colors.primary.yellow,
            borderColor: colors.primary.yellow,
            '&:hover': { backgroundColor: `${colors.primary.yellow}20`, borderColor: colors.primary.yellow },
          }}
        >
          Tentar novamente
        </Button>
      )}
    </Box>
  );
};
